export enum ContentType {
    JSON = 0,
    FORM = 1,
    STRING = 2
}